/* Tüftlerei-Ratgeber: Fräszeit-Rechner
   Die Fräse fährt quer über die Plattenbreite, fährt ohne Schnitt zurück und rückt in Längsrichtung weiter.
   Alle Texte kommen aus der Sektion (Theme-Editor, übersetzbar). */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg';

  function init(root) {
    if (!root || root.__trFz) return;
    var q = function (n) { return root.querySelector('[data-el="' + n + '"]'); };
    var cfg = {};
    try { cfg = JSON.parse(q('cfg').textContent); } catch (e) { cfg = {}; }
    var T = cfg.t || {};
    var faktor = cfg.spaeneFaktor > 0 ? cfg.spaeneFaktor : 4;
    var anlauf = cfg.anlauf >= 0 ? cfg.anlauf : 10;
    var lang = document.documentElement.lang || 'de';
    var nf = function (v, d) { return v.toLocaleString(lang, { minimumFractionDigits: d, maximumFractionDigits: d }); };
    var fmt = {
      L: function (v) { return v + ' cm'; }, B: function (v) { return v + ' cm'; }, D: function (v) { return v + ' mm'; },
      U: function (v) { return v + ' %'; }, A: function (v) { return nf(v, 1) + ' mm'; }, Z: function (v) { return nf(v, 1) + ' mm'; },
      V: function (v) { return nf(v, 1) + ' m/min'; }, R: function (v) { return nf(v, 1) + ' m/min'; }, T: function (v) { return v + ' s'; }
    };
    var ids = ['L', 'B', 'D', 'U', 'A', 'Z', 'V', 'R', 'T'];
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var S = {}, n = 1, k = 1, x0 = 0, y0 = 16, xs = [], i = 0, ph = 0, t0 = 0, alive = true;

    function model(p) {
      var d = p.D / 10, s = d * (1 - p.U / 100);
      var nb = p.L <= d ? 1 : Math.ceil((p.L - d) / s - 1e-9) + 1;
      var pass = Math.max(1, Math.ceil(p.A / p.Z - 1e-9));
      var w = (p.B + d + anlauf) / 100;
      var sides = p.both ? 2 : 1;
      var cnt = nb * pass * sides;
      var tCut = cnt * w / p.V, tBack = cnt * w / p.R, tShift = cnt * p.T / 60;
      var solid = p.L * p.B * (p.A / 10) / 1000 * sides;
      return { n: nb, pass: pass, sides: sides, way: cnt * w * 2, tCut: tCut, tBack: tBack, tShift: tShift, total: tCut + tBack + tShift, loose: solid * faktor };
    }
    function hm(min) {
      var m = Math.round(min);
      if (m < 60) return Math.max(1, m) + ' min';
      var h = Math.floor(m / 60), r = m % 60;
      return h + ' h' + (r ? ' ' + r + ' min' : '');
    }
    function mk(t, a) { var e = document.createElementNS(NS, t); for (var key in a) e.setAttribute(key, a[key]); return e; }
    function clone(o, extra) { var c = {}; for (var key in o) c[key] = o[key]; for (var x in extra) c[x] = extra[x]; return c; }

    function drawChart() {
      var svg = q('ch'); if (!svg) return; svg.innerHTML = '';
      var W = 600, H = 210, l = 52, r = 16, t = 12, b = 30, pts = [], D;
      for (D = 20; D <= 60; D++) pts.push([D, model(clone(S, { D: D })).total]);
      var maxV = Math.max.apply(null, pts.map(function (p) { return p[1]; }));
      var steps = [5, 10, 15, 20, 30, 60, 120, 180, 240, 360, 480];
      var step = 0; for (var j = 0; j < steps.length; j++) { if (maxV / steps[j] <= 4) { step = steps[j]; break; } }
      if (!step) { var hrs = maxV / 240, p10 = Math.pow(10, Math.floor(Math.log10(hrs))), qq = hrs / p10; step = (qq <= 1 ? 1 : qq <= 2 ? 2 : qq <= 5 ? 5 : 10) * p10 * 60; }
      var top = Math.ceil(maxV / step) * step;
      var X = function (d) { return l + (d - 20) / 40 * (W - l - r); };
      var Y = function (v) { return t + (1 - v / top) * (H - t - b); };
      for (var v = 0; v <= top + 1e-9; v += step) {
        svg.appendChild(mk('line', { x1: l, x2: W - r, y1: Y(v), y2: Y(v), style: 'stroke:var(--tr-line);stroke-width:1' }));
        var tx = mk('text', { x: l - 8, y: Y(v) + 4, 'text-anchor': 'end' });
        tx.textContent = v === 0 ? '0' : (v % 60 === 0 ? (v / 60) + ' h' : (v < 60 ? v + ' min' : Math.floor(v / 60) + ' h ' + (v % 60)));
        svg.appendChild(tx);
      }
      [20, 30, 40, 50, 60].forEach(function (d) { var tx = mk('text', { x: X(d), y: H - 8, 'text-anchor': 'middle' }); tx.textContent = d + ' mm'; svg.appendChild(tx); });
      svg.appendChild(mk('polyline', { points: pts.map(function (p) { return X(p[0]) + ',' + Y(p[1]); }).join(' '), style: 'fill:none;stroke:var(--tr-ink-2);stroke-width:2;stroke-linejoin:round' }));
      var cur = model(S).total;
      svg.appendChild(mk('line', { x1: X(S.D), x2: X(S.D), y1: Y(cur), y2: H - b, style: 'stroke:var(--tr-accent);stroke-width:1;stroke-dasharray:3 3' }));
      svg.appendChild(mk('circle', { cx: X(S.D), cy: Y(cur), r: 6, style: 'fill:var(--tr-accent);stroke:var(--tr-panel);stroke-width:2' }));
      var lab = mk('text', { x: Math.min(X(S.D) + 10, W - r - 70), y: Math.max(Y(cur) - 10, t + 10), style: 'fill:var(--tr-ink);font-weight:500' });
      lab.textContent = hm(cur); svg.appendChild(lab);
    }

    function drawPlate() {
      var d = S.D / 10, s = d * (1 - S.U / 100);
      k = Math.min(568 / S.L, 240 / S.B);
      var W = S.L * k, H = S.B * k; x0 = (600 - W) / 2;
      q('sv').setAttribute('viewBox', '0 0 600 ' + Math.round(H + 32));
      xs = []; for (var j = 0; j < n; j++) xs.push(Math.min(d / 2 + j * s, S.L - d / 2));
      var g = q('pl'); g.innerHTML = '';
      g.appendChild(mk('rect', { x: x0, y: y0, width: W, height: H, rx: 3, style: 'fill:var(--tr-wood);stroke:var(--tr-wood-edge);stroke-width:1.5' }));
      for (var m = 1; m < 5; m++) g.appendChild(mk('line', { x1: x0 + 6, x2: x0 + W - 6, y1: y0 + H * m / 5 + (m % 2 ? 3 : -2), y2: y0 + H * m / 5, style: 'stroke:var(--tr-wood-edge);stroke-opacity:.25;stroke-width:1' }));
      var st = mk('g', { 'data-el': 'st' }); g.appendChild(st);
      g.appendChild(mk('rect', { 'data-el': 'cur', x: 0, y: y0, width: d * k, height: 0, style: 'fill:var(--tr-cut);fill-opacity:.55' }));
      g.appendChild(mk('circle', { 'data-el': 'ro', cx: x0 + xs[0] * k, cy: y0 - d * k / 2, r: d * k / 2, style: 'fill:var(--tr-accent);fill-opacity:.85;stroke:var(--tr-accent);stroke-width:1.5' }));
      if (reduce) xs.forEach(function (x) { st.appendChild(mk('rect', { x: x0 + x * k - d * k / 2, y: y0, width: d * k, height: H, style: 'fill:var(--tr-cut);fill-opacity:.55' })); });
      i = 0; ph = 0; t0 = performance.now();
    }

    function calc() {
      ids.forEach(function (key) { S[key] = parseFloat(q(key).value); q(key + 'o').textContent = fmt[key](S[key]); });
      S.both = q('both').checked;
      var m = model(S); n = m.n;
      q('rt').textContent = hm(m.total);
      q('rtsub').textContent = q('rtsub').getAttribute('data-base') + (m.sides === 2 ? (T.beideSeiten || '') : (T.eineSeite || ''));
      q('rn').textContent = m.n;
      q('rp').textContent = m.pass + (m.sides === 2 ? ' ' + (T.zweiSeiten || '× 2') : '');
      q('rw').textContent = m.way < 1000 ? Math.round(m.way) + ' m' : nf(m.way / 1000, 1) + ' km';
      var pc = function (v) { return Math.round(v / m.total * 100); };
      q('bc').style.width = pc(m.tCut) + '%'; q('bb').style.width = pc(m.tBack) + '%'; q('bs').style.width = (100 - pc(m.tCut) - pc(m.tBack)) + '%';
      q('sc').textContent = hm(m.tCut); q('sb').textContent = hm(m.tBack); q('ss').textContent = hm(m.tShift);
      q('rs').textContent = (T.ca ? T.ca + ' ' : '') + (m.loose < 10 ? nf(m.loose, 1) : Math.round(m.loose)) + ' l';
      var f = m.loose / parseFloat(q('tank').value);
      q('rtank').textContent = f < 1 ? (T.behaelterPasst || '') : '≈ ' + nf(f, 1) + ' ' + (T.behaelterVoll || '');
      drawChart(); drawPlate();
    }

    function tick(now) {
      if (!alive) return;
      if (!document.body.contains(root)) { alive = false; return; }
      var ro = q('ro'), cur = q('cur');
      if (ro && xs.length && !reduce) {
        var H = S.B * k, r = S.D / 20 * k, cut = Math.max(180, Math.min(1200, 16000 / n)), back = cut * 0.45, e = now - t0, xc = x0 + xs[i] * k, f, cy;
        if (ph === 0) {
          f = Math.min(e / cut, 1); cy = y0 - r + f * (H + 2 * r);
          ro.setAttribute('cx', xc); ro.setAttribute('cy', cy); ro.style.fillOpacity = 0.85; ro.style.strokeDasharray = '';
          cur.setAttribute('x', xc - r); cur.setAttribute('height', Math.max(0, Math.min(cy - y0 + r, H)));
          if (f >= 1) { q('st').appendChild(mk('rect', { x: xc - r, y: y0, width: 2 * r, height: H, style: 'fill:var(--tr-cut);fill-opacity:.55' })); cur.setAttribute('height', 0); ph = 1; t0 = now; }
        } else {
          f = Math.min(e / back, 1);
          var nx = i + 1 < n ? x0 + xs[i + 1] * k : xc; cy = y0 + H + r - f * (H + 2 * r);
          ro.setAttribute('cx', xc + (nx - xc) * f); ro.setAttribute('cy', cy); ro.style.fillOpacity = 0; ro.style.strokeDasharray = '4 3';
          if (f >= 1) { i++; ph = 0; t0 = now; if (i >= n) { i = 0; q('st').innerHTML = ''; } }
        }
      }
      requestAnimationFrame(tick);
    }

    var pbtn = Array.prototype.slice.call(root.querySelectorAll('[data-el="preset"]'));
    function clearPreset() { pbtn.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); }); }
    function markPreset() {
      clearPreset();
      pbtn.forEach(function (b) { if (+b.getAttribute('data-l') === +q('L').value && +b.getAttribute('data-b') === +q('B').value) b.setAttribute('aria-pressed', 'true'); });
    }
    pbtn.forEach(function (b) {
      b.addEventListener('click', function () { q('L').value = b.getAttribute('data-l'); q('B').value = b.getAttribute('data-b'); markPreset(); calc(); });
    });
    ids.forEach(function (key) { q(key).addEventListener('input', function () { if (key === 'L' || key === 'B') markPreset(); calc(); }); });
    q('both').addEventListener('change', calc);
    q('tank').addEventListener('change', calc);
    q('rtsub').setAttribute('data-base', q('rtsub').textContent);

    root.__trFz = true;
    markPreset(); calc(); requestAnimationFrame(tick);
  }

  function initAll(scope) {
    var list = (scope || document).querySelectorAll('[data-tr-fraeszeit]');
    for (var j = 0; j < list.length; j++) init(list[j]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
